import { useState } from "react";
import DatePicker from "react-datepicker";
import { ReactComponent as DateIcon } from "../../assets/calender.svg";

import "react-datepicker/dist/react-datepicker.css";
import formatDate from "../../utils/dateFormater";
const DateSelect = ({ allow, setSelectedDate, selectedDate, className }) => {
  return (
    <div className={`relative `}>
      <DatePicker
        selected={selectedDate}
        onChange={(date) => setSelectedDate(formatDate(date))}
        className={`outline-purple-btn flex gap-2 items-center cursor-pointer bg-slate-100  ${className}`}
        maxDate={allow ? new Date() : null}
      />
      <span className="absolute right-5 top-1/2 translate-y-[-50%]">
        <DateIcon />
      </span>
    </div>
  );
};

export default DateSelect;
